import React, { Component } from 'react';
import './App.css';

// 1. 引入国际化相关
import { withTranslation } from 'react-i18next';
import './i18n'; 

import { HashRouter, Routes, Route } from 'react-router-dom';
import AboutPage from './AboutPage';
import Home from './Home';
import First from './First';
import Second from './Second';
import Third from './Third';
import Eighth from './eighth';
import Fifth from './fifth';
import Fourth from './fourth';
import Fourth1 from './fourth1';
import Fourth2 from './fourth2';
import Fourth3 from './fourth3';
import Fourth4 from './fourth4';
import Fourth5 from './fourth5';
import Fourth6 from './fourth6';
import Fourth7 from './fourth7';
import Fourth8 from './fourth8';
import Fourth9 from './fourth9';
import Ninth from './ninth';
import Seventh from './seventh';
import Tenth from './tenth';
import Second1 from './second1';
import Second2 from './second2';
import Second3 from './second3';
import Second4 from './second4';
import Second5 from './second5';
import Second6 from './second6';
import Second7 from './second7';
import Second8 from './second8';
import Second9 from './second9';
import Second11 from './second11';
import Second12 from './second12';
import Second13 from './second13';
import Second21 from './second21';
import Second22 from './second22';
import Second23 from './second23';
import Second24 from './second24';
import Second31 from './second31';
import Second32 from './second32';
import Second33 from './second33';
import Second34 from './second34';
import Second41 from './second41';
import Second42 from './second42';
import Second51 from './second51';
import Second52 from './second52';
import Second53 from './second53';
import Second61 from './second61';
import Second62 from './second62';
import Second71 from './second71';
import Second72 from './second72';
import Second81 from './second81';
import Second91 from './second91';
import Second92 from './second92';
import Second93 from './second93';
import Sixth from './sixth';

class App extends Component {

  changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng); // 切换语言
  };

  render() {

    const { t } = this.props;

    return (
      <HashRouter>

        {/* 新增：语言切换按钮（可放到导航栏/全局位置） */}
        <div style={{  padding: 10, textAlign: 'right', backgroundColor: 'black', color: 'white'  }}>
          <button onClick={() => this.changeLanguage('zh')} style={{ marginRight: 8, color: 'black' }}>
            {t('chinese')}
          </button>
          <button onClick={() => this.changeLanguage('en')} style={{ color: 'black' }}>
            {t('english')}
          </button>
        </div>

        <Routes>
          {/* 示例：路由文本使用翻译函数 t() */}
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<First />} />
          <Route path="/third" element={<Third />} />
          <Route path="/second" element={<Second />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/eighth" element={<Eighth />} />
          <Route path="/fifth" element={<Fifth />} />
          <Route path="/fourth" element={<Fourth />} />
          <Route path="/fourth1" element={<Fourth1 />} />
          <Route path="/fourth2" element={<Fourth2 />} />
          <Route path="/fourth3" element={<Fourth3 />} />
          <Route path="/fourth4" element={<Fourth4 />} />
          <Route path="/fourth5" element={<Fourth5 />} />
          <Route path="/fourth6" element={<Fourth6 />} />
          <Route path="/fourth7" element={<Fourth7 />} />
          <Route path="/fourth8" element={<Fourth8 />} />
          <Route path="/fourth9" element={<Fourth9 />} />
          <Route path="/ninth" element={<Ninth />} />
          <Route path="/seventh" element={<Seventh />} />
          <Route path="/tenth" element={<Tenth />} />
          <Route path="/second1" element={<Second1 />} />
          <Route path="/second2" element={<Second2 />} />
          <Route path="/second3" element={<Second3 />} />
          <Route path="/second4" element={<Second4 />} />
          <Route path="/second5" element={<Second5 />} />
          <Route path="/second6" element={<Second6 />} />
          <Route path="/second7" element={<Second7 />} />
          <Route path="/second8" element={<Second8 />} />
          <Route path="/second9" element={<Second9 />} />
          <Route path="/second11" element={<Second11 />} />
          <Route path="/second12" element={<Second12 />} />
          <Route path="/second13" element={<Second13 />} />
          <Route path="/second21" element={<Second21 />} />
          <Route path="/second22" element={<Second22 />} />
          <Route path="/second23" element={<Second23 />} />
          <Route path="/second24" element={<Second24 />} />
          <Route path="/second31" element={<Second31 />} />
          <Route path="/second32" element={<Second32 />} />
          <Route path="/second33" element={<Second33 />} />
          <Route path="/second34" element={<Second34 />} />
          <Route path="/second41" element={<Second41 />} />
          <Route path="/second42" element={<Second42 />} />
          <Route path="/second51" element={<Second51 />} />
          <Route path="/second52" element={<Second52 />} />
          <Route path="/second53" element={<Second53 />} />
          <Route path="/second61" element={<Second61 />} />
          <Route path="/second62" element={<Second62 />} />
          <Route path="/second71" element={<Second71 />} />
          <Route path="/second72" element={<Second72 />} />
          <Route path="/second81" element={<Second81 />} />
          <Route path="/second91" element={<Second91 />} />
          <Route path="/second92" element={<Second92 />} />
          <Route path="/second93" element={<Second93 />} />
          <Route path="/sixth" element={<Sixth />} />
        </Routes>
      </HashRouter>
    );
  }
}

// 5. 用 withTranslation 包装 App 组件，注入国际化能力
export default withTranslation()(App);